import React from 'react';
import AdminBasePage from './AdminBasePage';

interface AdminMainPageProps {}

const AdminMainPage: React.FC<AdminMainPageProps> = () => <AdminBasePage />;

export default AdminMainPage;
